<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}" @mousedown.stop="">

          <div class="modal-body m-0">
            <devis-form contactSearch
              :invoiceType="devisFormData.invoiceType"
              :buyer="devisFormData.buyer"
              :propsDateExec="devisFormData.dateExec"
              :propsSellerIBAN="devisFormData.sellerIBAN"
              :propsInvoiceRef="devisFormData.invoiceRef"
              :propsProducts="devisFormData.products"
              :amountHT="devisFormData.amountHT"
              :amountTaxes="devisFormData.amountTaxes">
            </devis-form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DevisForm from '@/pages/attachments/DevisForm.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'PopupArchivage',
  components: {
    'devis-form': DevisForm,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    devisFormData: {
      type: Object
    }
  },
  data: () => {
    return {
      archiveLabel: ''
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    }
  }
}
</script>

<style>
</style>
